/** Options for storage writes. */
export interface StorageSetOptions {
  /**
   * Re-throw on write failure instead of swallowing it, so callers can react
   * (e.g. avoid discarding the only copy of the value). Defaults to `false`.
   */
  throwOnError?: boolean;
}

/**
 * Wrapper for `localStorage` that fails gracefully if not supported by the browser
 */
export const localStorage = {
  get: (key: string) => {
    try {
      return window.localStorage.getItem(key);
    } catch {
      return;
    }
  },
  set: (key: string, value: string, options?: StorageSetOptions) => {
    try {
      return window.localStorage.setItem(key, value);
    } catch (error) {
      if (options?.throwOnError) {
        throw error;
      }
      return;
    }
  },
  remove: (key: string) => {
    try {
      return window.localStorage.removeItem(key);
    } catch {
      return;
    }
  },
};

/**
 * Wrapper for `sessionStorage` that fails gracefully if not supported by the browser
 */
export const sessionStorage = {
  get: (key: string) => {
    try {
      return window.sessionStorage.getItem(key);
    } catch {
      return;
    }
  },
  set: (key: string, value: string, options?: StorageSetOptions) => {
    try {
      return window.sessionStorage.setItem(key, value);
    } catch (error) {
      if (options?.throwOnError) {
        throw error;
      }
      return;
    }
  },
  remove: (key: string) => {
    try {
      return window.sessionStorage.removeItem(key);
    } catch {
      return;
    }
  },
};
